import React, { useEffect, useState } from "react";
import { LoadContacts, LoadGroups, LoadScheduleMessages } from "../../actions";
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import GridComponent from "../shared/grid";
import PageHeaderComponent from "../shared/page-header.component";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../helpers/header.helper";
import { HeaderTemplate, dateComparator } from "../shared/grid/grid.services";
import { Dialog, DialogContent, DialogTitle, Popover, Tooltip } from "@mui/material";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { Contact, Group } from "../../models/conversations";
import { UtilityService } from "../../services/UtilityService";
import SendMessage from "../conversations/send-message-component";
import ConfirmDialog from "../shared/confirm-dialog.component";
import {
    ActionLabels,
    appNote,
    buttonLabels,
    pageTitles,
    ScheduledMessageMassAction,
    ScheduleMessageStatusText,
    ScheduleMessageTypeTexts,
    ToasterTexts,
    GridStatusLabelVariant,
    emptyLabels
} from "../shared/constants";
import { MessageService } from "../../services/MessageService";
import { ScheduleMessageStatus, ScheduleMessageType, ScheduledMessageModel } from "../../models/conversations/schedule-messages.model";
import { ToFieldRender } from "../shared/grid/toFiledRender";
import { TypeRenderer } from "../shared/grid/typeRendrer";
import { customStringComparator } from "../../helpers/custom-comparators";
import { MessageTagRenderer } from "../shared/grid/msgTagRendrer";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import {
    AddScheduleMessageIcon, CancelIcon, DuplicateIcon, EditIcon, ResumeIcon, ScheduleDailyIcon,
    ScheduleMonthlyIcon, ScheduleOneTimeIcon, ScheduleWeeklyIcon, StopIcon, TrashIcon,
    MultiSelectDeleteIcon, MultiSelectCrossIcon, MultiSelectResumeIcon, MultiSelectStopIcon,
    ScheduleMessagePrimaryDarkIcon, TimmerIcon, VoipIcon as SemiAnnualIcon, MSteamsIcon as AnnualIcon,
    AddOnViewIcon
} from "../../icon";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import PullToRefresh from "react-simple-pull-to-refresh";
import FilterComponent from "../shared/filters/filter.component";
import _ from 'lodash';
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";

interface Props { }

const ScheduledMessage = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Contacts: Contact[] = useSelector(selector.contacts)
    const Groups: Group[] = useSelector(selector.groups)
    const ScheduleMsg: ScheduledMessageModel[] = useSelector(selector.scheduleMessages)
    const IsScheduleMessageImporting: boolean = useSelector(selector.IsScheduleMessageImporting)


    const [OpenScheduledMessage, setOpenScheduledMessage] = useState<boolean>(false);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [ShowMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
    const [CheckedScheduledMessages, setCheckedScheduledMessages] = useState<ScheduledMessageModel[]>([]);
    const [openMassAction, setOpenMassAction] = useState<boolean>(false);
    const [Text, setText] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [MobileMenu, setMobileMenu] = useState<boolean>(false)
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [OperatingScheduledMessage, setOperatingScheduledMessage] = useState<ScheduledMessageModel>();
    const [IsDuplicate, setIsDuplicate] = useState<boolean>(false);
    const [Show, setShow] = useState<boolean>(false);
    const [ClickRowId, setClickRowId] = useState<string>("");
    const [DialogAction, setDialogAction] = useState<string>("");
    const [anchorEl, setAnchorEl] = useState<Element | null>();
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [isCampaign, setIsCampaign] = useState<boolean>(false)


    useEffect(() => {
        if (ScheduleMsg.length === 0) {
            LoadScheduleMessages(dispatch)
        }
    }, [])

    const contactName = (data) => {
        let names: string[] = [];
        if (data.ContactIds?.length || data.PhoneNumbers?.length) {
            const phoneSet = new Set(data.PhoneNumbers || []);
            const contactIdSet = new Set(data.ContactIds || []);

            const savedContacts = Contacts.filter(x => contactIdSet.has(x.ID) || phoneSet.has(UtilityService.unmaskPhoneNumber(x.PhoneNumber)));

            if (savedContacts?.length) {
                names.push(...savedContacts.map(c => c.Name));
            }

            const unsavedNumbers = (data.PhoneNumbers || []).filter(x => !Contacts.some(y => UtilityService.unmaskPhoneNumber(y.PhoneNumber) === x));
            if (unsavedNumbers?.length) {
                names.push(...unsavedNumbers.map(x => UtilityService.maskPhoneNumberOnLength(x)));
            }
        }
        let count = names?.length;
        if (count > 0) {
            return `${names[0]} ${count > 2 ? `+ ${count - 1} Others` : count === 2 ? `+ ${count - 1} Other` : ""}`.trim();
        }
    }

    const ScheduleMessageColumnDefs: ColDef[] = [
        {
            field: "To",
            headerName: "To",
            //mainly used for sorting
            valueGetter: (params: ValueGetterParams) => {
                if (params.data.Campaign?.Name) {
                    return params.data.Campaign?.Name
                }
                else if (params.data.Groups?.length) {
                    return Groups?.find(x => params.data.Groups.find(y => y.ID === x.ID))?.Name
                }
                else {
                    return contactName(params.data)
                }
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                const groupContactCount = () => {
                    if (Groups.find(x => params.data.Groups.find(y => y.ID === x.ID))) {
                        return Groups.find(x => params.data.Groups.find(y => y.ID === x.ID))?.ContactsCount
                    }
                }
                const campaignName = params.data.Campaign?.Name
                if (params.data) {
                    const To = {
                        component: ToFieldRender,
                        params: {
                            Count: !!params.data.Groups?.length && groupContactCount(),
                            GroupName: !!params.data.Groups?.length && Groups?.find(x => params.data.Groups.find(y => y.ID === x.ID))?.Name,
                            Label: (params.data.Groups?.length === 1 || !!campaignName) ? "" : contactName(params.data), campaignName: campaignName
                        }
                    }
                    return To
                }
                return undefined
            },
            headerCheckboxSelection: IsMobileDevice ? false : true,
            checkboxSelection: IsMobileDevice ? false : true,
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "type",
            headerName: "Type",
            hide: IsMobileDevice,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Type") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Type == ScheduleMessageType.WEEKLY
                        ? ScheduleMessageTypeTexts.WEEKLY
                        : params.data.Type == ScheduleMessageType.MONTHLY
                            ? ScheduleMessageTypeTexts.MONTHLY
                            : params.data.Type == ScheduleMessageType.DAILY
                                ? ScheduleMessageTypeTexts.DAILY
                                : params.data.Type == ScheduleMessageType.EVERY_6_MONTHS
                                    ? ScheduleMessageTypeTexts.EVERY_6_MONTHS : params.data.Type == ScheduleMessageType.EVERY_YEAR
                                        ? ScheduleMessageTypeTexts.EVERY_YEAR :
                                        params.data.Type == ScheduleMessageType.EVERY_2_WEEKS ? ScheduleMessageTypeTexts.EVERY_2_WEEKS : ScheduleMessageTypeTexts.ONE_TIME
                    const icon = params.data.Type == ScheduleMessageType.WEEKLY
                        ? ScheduleWeeklyIcon
                        : params.data.Type == ScheduleMessageType.MONTHLY
                            ? ScheduleMonthlyIcon
                            : params.data.Type == ScheduleMessageType.DAILY
                                ? ScheduleDailyIcon
                                : params.data.Type == ScheduleMessageType.EVERY_6_MONTHS ? SemiAnnualIcon : params.data.Type == ScheduleMessageType.EVERY_YEAR ? AnnualIcon : params.data.Type == ScheduleMessageType.EVERY_2_WEEKS ? AddOnViewIcon : ScheduleOneTimeIcon
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Label: label, Id: params.data.ID, Icon: icon
                        }
                    }
                    return Type;
                }
                return undefined
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Type == ScheduleMessageType.WEEKLY ? ScheduleMessageTypeTexts.WEEKLY : params.data.Type == ScheduleMessageType.MONTHLY ? ScheduleMessageTypeTexts.MONTHLY : params.data.Type == ScheduleMessageType.DAILY ? ScheduleMessageTypeTexts.DAILY : ScheduleMessageTypeTexts.ONE_TIME
            }
        },
        {
            field: "Message",
            minWidth: IsMobileDevice ? 2 : 400,
            headerName: "Message",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Message
            },
            comparator: customStringComparator,
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const Message = {
                        component: MessageTagRenderer,
                        params: {
                            Message: params.data.Message ? params.data.Message : "", ShowMediaIcon: !!params.data?.Media?.length
                        }
                    }
                    return Message;
                }
                return undefined
            },
            autoHeight: true,
        },
        {
            field: "status",
            headerName: "Status",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Status == ScheduleMessageStatus.SENT ? ScheduleMessageStatusText.SENT : params.data.Status == ScheduleMessageStatus.STOPPED ? ScheduleMessageStatusText.STOPPED : ScheduleMessageStatusText.SCHEDULED
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status == ScheduleMessageStatus.SENT
                        ? ScheduleMessageStatusText.SENT
                        : params.data.Status == ScheduleMessageStatus.STOPPED
                            ? ScheduleMessageStatusText.STOPPED
                            : ScheduleMessageStatusText.SCHEDULED

                    const Variant = params.data.Status == ScheduleMessageStatus.SENT
                        ? GridStatusLabelVariant.Active
                        : params.data.Status == ScheduleMessageStatus.STOPPED
                            ? GridStatusLabelVariant.Danger
                            : GridStatusLabelVariant.Warning

                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Label: label, Id: params.data.ID, Variant: Variant,
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
        {
            field: "EndScheduledDateTime",
            headerName: "End Schedule Date Time",
            valueGetter: (params: ValueGetterParams) => params.data.EndScheduledDateTime === null
                ? "--"
                : UtilityService.convertToDateTimeFormat(
                    params.data.EndScheduledDateTime
                ),
            hide: IsMobileDevice
        },
        {
            field: "NextScheduledDateTime",
            headerName: "Next Scheduled Date Time",
            valueGetter: (params: ValueGetterParams) => params.data.Status == ScheduleMessageStatus.SENT
                ? "--"
                : UtilityService.convertToDateTimeFormat(
                    params.data.NextScheduledDateTime
                ),
            valueFormatter: (params: ValueFormatterParams) => {
                return params.data.Status == ScheduleMessageStatus.SENT
                    ? "--"
                    : UtilityService.convertToDateTimeFormat(
                        params.data.NextScheduledDateTime
                    )
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.NextScheduledDateTime, nodeB.data.NextScheduledDateTime),
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            hide: IsMobileDevice,
            cellRenderer: params =>
                <ActionsRenderer MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false
        },
    ]

    const getMenuActions = (data: ScheduledMessageModel) => {
        return [
            {
                Name: (data as ScheduledMessageModel)?.Status === ScheduleMessageStatus.SCHEDULED ? ActionLabels.EDIT : undefined,
                Icon: (data as ScheduledMessageModel)?.Status === ScheduleMessageStatus.SCHEDULED ? EditIcon : undefined,
                Hide: (data as ScheduledMessageModel)?.Status === ScheduleMessageStatus.SENT || (data as ScheduledMessageModel)?.Status === ScheduleMessageStatus.STOPPED,
                OnClick: () => openScheduledMessage(data as ScheduledMessageModel),
            },
            {
                Name: ActionLabels.DUPLICATE,
                Icon: DuplicateIcon,
                OnClick: () => openScheduledMessage(data as ScheduledMessageModel, true),
                Hide: true
            },
            {
                Name: (data as ScheduledMessageModel)?.Status == ScheduleMessageStatus.STOPPED ? ActionLabels.RESUME : ActionLabels.STOP,
                Icon: (data as ScheduledMessageModel)?.Status === ScheduleMessageStatus.STOPPED ? ResumeIcon : StopIcon,
                Hide: !(new Date() < new Date((data as ScheduledMessageModel)?.NextScheduledDateTime) || (new Date() > new Date((data as ScheduledMessageModel)?.NextScheduledDateTime) && (data as ScheduledMessageModel)?.Type !== ScheduleMessageType.ONE_TIME)),
                OnClick: () => openConfirmDialog((data as ScheduledMessageModel).ID, (data as ScheduledMessageModel).Status === ScheduleMessageStatus.STOPPED)
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => openDeleteConfirmDialog((data as ScheduledMessageModel).ID || "")
            }
        ]
    }

    const initialFilterOptions = () => {
        const selectedValues = filterOptions
            .flatMap((category) => category.Options)
            .filter((option) => option.IsSelected)
            .map((option) => `${option.Key}:${option.Value}`);

        const filterData: CustomFilterCategory[] = [
            {
                Id: 1,
                Title: "Type",
                IsSelectedAll: false,
                Options: _(ScheduleMsg)
                    .map((row) => ({
                        Key: "Type",
                        Id: row.ID,
                        Label: row.Type === 0 ? ScheduleMessageTypeTexts.ONE_TIME : row.Type === 1 ? ScheduleMessageTypeTexts.DAILY : row.Type === 2 ? ScheduleMessageTypeTexts.WEEKLY : row.Type === 3 ? ScheduleMessageTypeTexts.MONTHLY : row.Type === 4 ? ScheduleMessageTypeTexts.EVERY_6_MONTHS : row.Type === 5 ? ScheduleMessageTypeTexts.EVERY_YEAR : ScheduleMessageTypeTexts.EVERY_2_WEEKS,
                        Value: row.Type as any,
                        IsSelected: selectedValues.includes(`Type:${row.Type}`)
                    }))
                    .uniqBy('Label')
                    .value()
            },
            {
                Id: 2,
                Title: "Status",
                IsSelectedAll: false,
                Options: _(ScheduleMsg)
                    .map((row) => ({
                        Key: "Status",
                        Id: row.ID,
                        Label: row.Status === ScheduleMessageStatus.NONE ? "None" : row.Status === ScheduleMessageStatus.SCHEDULED ? ScheduleMessageStatusText.SCHEDULED : row.Status === ScheduleMessageStatus.STOPPED ? ScheduleMessageStatusText.STOPPED : ScheduleMessageStatusText.SENT,
                        Value: row.Status,
                        IsSelected: selectedValues.includes(`Status:${row.Status}`),
                    }))
                    .uniqBy('Label')
                    .value()
            },
        ]

        filterData.forEach((category) => {
            category.IsSelectedAll = category.Options.length > 0 && category.Options.every((option) => option.IsSelected)
        })

        setFilterOptions(filterData)
        setSelectedFilterTypes(UtilityService.getFilterTypes(filterData).result)
    }

    useEffect(() => {
        initialFilterOptions()
        setHeaderCount(ScheduleMsg.length || 0);
    }, [ScheduleMsg])

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    const openDeleteConfirmDialog = (ID: string) => {
        setShow(true);
        setClickRowId(ID);
        setText(appNote.SCHEDULED_MESSAGE_DELETE);
        setDialogAction("Delete");
        setButtonName("Delete");
        setMobileMenu(false);
        setIsLoading(false);
    };

    const openConfirmDialog = (rowId: string, IsDisabled: boolean) => {
        let text = IsDisabled ? appNote.SCHEDULED_MESSAGE_RESUME : appNote.SCHEDULED_MESSAGE_STOP;
        let btnName = IsDisabled ? "Resume" : "Stop";
        setShow(true);
        setClickRowId(rowId);
        setText(text);
        setButtonName(btnName);
        setDialogAction("Stop");
        setMobileMenu(false);
        setIsLoading(false);
    }

    const openScheduledMessage = (ScheduledMessage?: ScheduledMessageModel, isDuplicate?: boolean) => {
        setOpenScheduledMessage(true);
        setOperatingScheduledMessage(ScheduledMessage);
        setMobileMenu(false);
        setIsDuplicate(!!isDuplicate)
    };

    const handleSuccess = (isResetFilters: boolean = false) => {
        if (!!Contacts && !!Groups) {
            if (!OpenScheduledMessage) {
                if (!!columnApi) {
                    columnApi.resetColumnState()
                }

                if (!!gridApi) {
                    gridApi.refreshCells({ force: true })
                }
            }
        }
        setShowMultiActionButtons(false);
        setCheckedScheduledMessages([]);
        closeSendMessage(isResetFilters)
    }

    useEffect(() => {
        setHeaderTitle(pageTitles.SCHEDULED_MESSAGES);
        setRefreshHandler(gridRefresh);
        setHeaderCount(ScheduleMsg.length || 0);

        return setHeaderTitle
    }, [gridApi, columnApi])

    const gridRefresh = () => {
        // LoadGroups(dispatch);
        // LoadContacts(dispatch)
        LoadScheduleMessages(dispatch)
        if (!!columnApi) {
            columnApi.resetColumnState()
        }
        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
        setShowMultiActionButtons(false);
        gridApi.deselectAll();
        setFilterOptions([])
        setSelectedFilterTypes([])
    }

    // const getGridTitle = () => {
    //     if (ShowMultiActionButtons) {
    //         if (CheckedScheduledMessages && CheckedScheduledMessages.length > 1) {
    //             return CheckedScheduledMessages.length + " Items selected";
    //         }
    //         else if (CheckedScheduledMessages && CheckedScheduledMessages.length === 1) {
    //             return "1 Item selected";
    //         }
    //     }
    //     else {
    //         if (ScheduleMsg.length === 1) {
    //             return "1 Scheduled Message"
    //         }
    //         else {
    //             return ScheduleMsg.length + " " + pageTitles.SCHEDULED_MESSAGES
    //         }
    //     }
    // }

    const searchScheduleMessages = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const openMassActionConfirmDialog = (action: string) => {
        let text = action === ScheduledMessageMassAction.DELETE ? appNote.MASS_ACTION_TEXT.replace('<action>', ScheduledMessageMassAction.DELETE).replace('<name>', CheckedScheduledMessages.length > 1 ? pageTitles.SCHEDULED_MESSAGES.toLocaleLowerCase() : ScheduledMessageMassAction.SCHEDULE_MESSAGE) : action === ScheduledMessageMassAction.STOP ? appNote.MASS_ACTION_TEXT.replace('<action>', ScheduledMessageMassAction.STOP).replace('<name>', CheckedScheduledMessages.length > 1 ? pageTitles.SCHEDULED_MESSAGES.toLocaleLowerCase() : ScheduledMessageMassAction.SCHEDULE_MESSAGE) : appNote.MASS_ACTION_TEXT.replace('<action>', ScheduledMessageMassAction.RESUME).replace('<name>', CheckedScheduledMessages.length > 1 ? pageTitles.SCHEDULED_MESSAGES.toLocaleLowerCase() : ScheduledMessageMassAction.SCHEDULE_MESSAGE)
        setOpenMassAction(true);
        setText(text);
        setButtonName(action);
        setMobileMenu(false);
        setIsLoading(false);

    }

    const clearSelection = () => {
        if (!!gridApi && !!CheckedScheduledMessages?.length) {
            gridApi.deselectAll();

        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi)
    }

    const onSelectionChanged = () => {
        let SelectedScheduleMessages: ScheduledMessageModel[] = gridApi.getSelectedRows()
        if (gridApi && SelectedScheduleMessages.length > 0) {
            setSelectedCount(SelectedScheduleMessages.length)
            setShowMultiActionButtons(true);
            setCheckedScheduledMessages(SelectedScheduleMessages);
        }
        else {
            setSelectedCount(SelectedScheduleMessages.length)
            setShowMultiActionButtons(false);
        }
    }

    const HandleRowClick = (row: ScheduledMessageModel) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
            setOperatingScheduledMessage(row);
        }
    }

    const closeSendMessage = (isResetFilters: boolean = false) => {
        setOpenScheduledMessage(false);
        setIsDuplicate(false);
        clearSelection()
        if (isResetFilters) {
            setFilterOptions([])
            setSelectedFilterTypes([])
        }
    };

    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (IsMobileDevice) {
            setShowFilterOptions(true);
        }
        else {
            setAnchorEl(event.currentTarget)
        }
    }


    const closeConfirmDialog = (isConfim: boolean) => {
        var action = DialogAction;
        if (!!isConfim && (action === "Delete")) {
            setIsLoading(true);
            let scheduledMessage = ScheduleMsg.find(
                (x: ScheduledMessageModel) => x.ID === ClickRowId
            );
            let scheduledMessageName = contactName(scheduledMessage);

            MessageService.deleteScheduleMessage(scheduledMessage?.ID)
                .then((res) => {
                    setToast(
                        ToasterTexts.SCHEDULED_MESSAGE_DELETE_SUCCESS.replace(
                            "<Name>",
                            scheduledMessageName
                        ),
                        ToasterType.SUCCESS
                    );
                    setShow(false);
                    setMobileMenu(false);
                    setClickRowId("");
                    setOperatingScheduledMessage(undefined);
                    setIsLoading(false);
                    setCheckedScheduledMessages([]);
                    clearSelection()
                    handleSuccess();
                })
                .catch((err) => {
                    setToast(
                        ToasterTexts.SCHEDULED_MESSAGE_DELETE_FAILED.replace(
                            "<Name>",
                            scheduledMessageName
                        ),
                        ToasterType.SUCCESS
                    );

                    setShow(false);
                    setMobileMenu(false);
                    setClickRowId("");
                    setOperatingScheduledMessage(undefined);
                    setIsLoading(false);
                    setCheckedScheduledMessages([]);
                    clearSelection()
                });
        } else if (!!isConfim && (action === "Stop")) {
            setIsLoading(true);
            let scheduledMessage = ScheduleMsg.find(
                (x: ScheduledMessageModel) => x.ID === ClickRowId
            );
            let scheduledMessageName = contactName(scheduledMessage);

            MessageService.updateScheduleMessageStatus(scheduledMessage?.ID)
                .then((res) => {
                    setToast(
                        scheduledMessage?.Status === ScheduleMessageStatus.STOPPED
                            ? ToasterTexts.SCHEDULED_MESSAGE_RESUME_SUCCESS.replace(
                                "<Name>",
                                scheduledMessageName
                            )
                            : ToasterTexts.SCHEDULED_MESSAGE_STOP_SUCCESS.replace(
                                "<Name>",
                                scheduledMessageName
                            ),
                        ToasterType.SUCCESS
                    );

                    setShow(false);
                    setMobileMenu(false);
                    setClickRowId("");
                    setOperatingScheduledMessage(undefined);
                    setIsLoading(false);
                    setCheckedScheduledMessages([]);
                    clearSelection()
                    handleSuccess();
                })
                .catch((err) => {
                    setToast(
                        scheduledMessage?.Status === ScheduleMessageStatus.STOPPED
                            ? ToasterTexts.SCHEDULED_MESSAGE_RESUME_SUCCESS.replace(
                                "<Name>",
                                scheduledMessageName
                            )
                            : ToasterTexts.SCHEDULED_MESSAGE_STOP_SUCCESS.replace(
                                "<Name>",
                                scheduledMessageName
                            ),
                        ToasterType.SUCCESS
                    );

                    setShow(false);
                    setMobileMenu(false);
                    setClickRowId("");
                    setOperatingScheduledMessage(undefined);
                    setIsLoading(false)
                    setCheckedScheduledMessages([]);
                    clearSelection()
                });
        } else {
            setShow(false);
            setMobileMenu(false);
            setClickRowId("");
            setOperatingScheduledMessage(undefined);
            setIsLoading(false);
        }
    };

    const closeMassActionConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            setIsLoading(true);
            const data = CheckedScheduledMessages.map((item) => {
                return item.ID
            })
            MessageService.scheduleMessagesMassAction(ButtonName, data).then((res) => {
                handleSuccess()
                ButtonName === ScheduledMessageMassAction.DELETE ? setToast(ToasterTexts.MULTIPLE_SCHEDULED_MESSAGE_DELETE_SUCCESS, ToasterType.SUCCESS) : ButtonName === ScheduledMessageMassAction.STOP ? setToast(ToasterTexts.MULTIPLE_SCHEDULED_MESSAGE_STOP_SUCCESS, ToasterType.SUCCESS) : setToast(ToasterTexts.MULTIPLE_SCHEDULED_MESSAGE_RESUME_SUCCESS, ToasterType.SUCCESS)
                setOpenMassAction(false);
                setButtonName('');
                setMobileMenu(false);
                setIsLoading(false);
                setCheckedScheduledMessages([]);
                clearSelection();
            }).catch(err => {
                if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    setIsLoading(false);
                    setCheckedScheduledMessages([]);
                    clearSelection();
                }
            })
        } else {
            setOpenMassAction(false);
            setButtonName('');
            setMobileMenu(false);
            setIsLoading(false);
        }
    };
    const CloseMobileMenu = () => {
        setMobileMenu(false);
    };

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => handleSuccess(true));

    const unsubscribeContactsCount = (GroupID) => {
        let group = Groups?.filter(x => x.ID == GroupID);
        let contactsFromGroups = group?.flatMap(x => x.Contacts);
        return contactsFromGroups?.filter((x, i) => contactsFromGroups?.findIndex(y => y?.ID === x?.ID) === i)?.filter(x => x.IsUnsubscribed).length
    }

    const handleCellRowClick = (e: any, row: any) => {
        if (!IsMobileDevice && e.colDef.field !== "Action") {
            openScheduledMessage(row)
        }
    }

    return (
        OpenScheduledMessage && IsMobileDevice ? (
            <SendMessage
                open={OpenScheduledMessage}
                ContactIDs={[...(OperatingScheduledMessage?.ContactIds ?? []),
                ...(OperatingScheduledMessage?.PhoneNumbers?.filter(
                    x => Contacts?.some(y => y?.MaskedPhoneNumber?.replace("+", "") === x)
                ) ?? [])]}
                GroupIDs={OperatingScheduledMessage?.Groups?.map((x) => x.ID)}
                Message={OperatingScheduledMessage?.Message}
                ScheduleType={OperatingScheduledMessage?.Type}
                ScheduleDateTime={OperatingScheduledMessage?.NextScheduledDateTime}
                ScheduleEndDateTime={OperatingScheduledMessage?.EndScheduledDateTime}
                handleClose={() => closeSendMessage(true)}
                handleSuccess={() => handleSuccess(true)}
                showScheduleType={true}
                ScheduledMessageID={IsDuplicate ? undefined : OperatingScheduledMessage?.ID}
                IsDuplicate={IsDuplicate}
                PhoneNumbers={OperatingScheduledMessage?.PhoneNumbers?.filter(x => Contacts?.some(y => y.MaskedPhoneNumber.replace("+", "") !== x))}
                isScheduleMsg={false}
                UnsubscribeContactCount={unsubscribeContactsCount(OperatingScheduledMessage?.Groups?.map(x => x.ID))}
                Campaign={OperatingScheduledMessage?.Campaign?.ID ? OperatingScheduledMessage?.Campaign : undefined}
                IsCampaign={isCampaign}
                SetIscompaign={(value: boolean) => setIsCampaign(value)}
                MultiMedia={OperatingScheduledMessage?.Media}
            />) :
            ShowFilterOptions && IsMobileDevice ? (
                <FilterComponent
                    Filters={filterOptions}
                    HandleApplyFilters={handleApplyFilters}
                    OnClose={handleCloseFilter}
                />
            ) :
                <>
                    <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                            <PageHeaderComponent
                                GridTitle={""}
                                Count={ScheduleMsg?.length}
                                Actions={!IsMobileDevice ? [{
                                    OnClick: () => openScheduledMessage(undefined),
                                    ButtonLabel: buttonLabels.ADD_SCHEDULED_MESSAGE,
                                    Icon: !IsMobileDevice ? AddScheduleMessageIcon : "",
                                    Variant: IsScheduleMessageImporting ? "disabled-btn" : "primary-btn",
                                },
                                {
                                    OnClick: () => navigate(AppRoutes.IMPORT_SCHEDULED_MESSAGES),
                                    ButtonLabel: "Import",
                                    Icon: !IsMobileDevice ? IsScheduleMessageImporting ? AddScheduleMessageIcon : ScheduleMessagePrimaryDarkIcon : "",
                                    Variant: IsScheduleMessageImporting ? "disabled-btn" : "secondary-btn",
                                }] : [{
                                    OnClick: () => openScheduledMessage(undefined),
                                    ButtonLabel: buttonLabels.ADD_SCHEDULED_MESSAGE,
                                    Icon: !IsMobileDevice ? AddScheduleMessageIcon : "",
                                    Variant: IsScheduleMessageImporting ? "disabled-btn" : "primary-btn",
                                }]}
                                HandleFilter={handleClickFilter}
                                ShowFilterIcon={true}
                                IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                onSearch={searchScheduleMessages}
                                PlaceHolder={"Search ..."}
                                ShowMultiActionButtons={ShowMultiActionButtons}
                                MultiActionButtons={[
                                    {
                                        Name: !!CheckedScheduledMessages.length && CheckedScheduledMessages.every(item => item.Status === ScheduleMessageStatus.STOPPED) ? ActionLabels.RESUME : !!CheckedScheduledMessages.length && CheckedScheduledMessages.every(item => item.Status === ScheduleMessageStatus.SCHEDULED) ? ActionLabels.STOP : ActionLabels.STOP,
                                        Variant: "primary",
                                        Hide: CheckedScheduledMessages.every(item => !(new Date() < new Date(item.NextScheduledDateTime))) || (CheckedScheduledMessages?.length > 1) || ((!!CheckedScheduledMessages && CheckedScheduledMessages.every(item => !(new Date() > new Date(item.NextScheduledDateTime))))) && (!!CheckedScheduledMessages && !CheckedScheduledMessages),
                                        ClassName: "mr-1",
                                        Icon: !!CheckedScheduledMessages.length && CheckedScheduledMessages.every(item => item.Status === ScheduleMessageStatus.STOPPED) ? MultiSelectResumeIcon : !!CheckedScheduledMessages.length && CheckedScheduledMessages.every(item => item.Status === ScheduleMessageStatus.SCHEDULED) ? MultiSelectStopIcon : MultiSelectStopIcon,
                                        OnClick: () => CheckedScheduledMessages?.length === 1 ? openConfirmDialog(CheckedScheduledMessages[0]?.ID, CheckedScheduledMessages[0]?.Status === ScheduleMessageStatus.STOPPED) : openMassActionConfirmDialog(CheckedScheduledMessages.every(item => item.Status === ScheduleMessageStatus.STOPPED) ? ScheduledMessageMassAction.RESUME : ScheduledMessageMassAction.STOP)
                                    },
                                    {
                                        Name: ActionLabels.DELETE,
                                        Variant: "primary",
                                        ClassName: "mr-1",
                                        Icon: MultiSelectDeleteIcon,
                                        OnClick: () => CheckedScheduledMessages?.length === 1 ? openDeleteConfirmDialog(CheckedScheduledMessages[0]?.ID || "") : openMassActionConfirmDialog(ScheduledMessageMassAction.DELETE)

                                    },
                                    {
                                        Name: ActionLabels.CLEAR_SELECTION,
                                        Variant: "text",
                                        ClassName: "p-0 mr-1 w-space",
                                        Icon: MultiSelectCrossIcon,
                                        OnClick: () => clearSelection()
                                    },
                                ]}
                            />
                            {IsScheduleMessageImporting && <div className='px-3 h6-semibold my-auto d-flex align-center'> <TimmerIcon className="mr-1" /><div className=''>
                                {`Schedule message import is in progress. You can continue using the application while your schedule messages are being imported`}</div>
                            </div>}
                            <GridComponent
                                ColumnDefs={ScheduleMessageColumnDefs}
                                OnGridReady={onGridReady}
                                RowData={ScheduleMsg}
                                OnSelectionChanged={onSelectionChanged}
                                OnGridRowClick={HandleRowClick}
                                IsPaginationEnabled={!IsMobileDevice}
                                EmptyLabel={emptyLabels.SCHEDULED_MESSAGES}
                                LockVisible={IsMobileDevice}
                                filterOptions={filterOptions}
                                IsFilterPresent={true}
                                gridApi={gridApi}
                                OnGridCellRowClick={handleCellRowClick}
                                ShowRowPointer={true}
                            />
                            {
                                OpenScheduledMessage && (
                                    <SendMessage
                                        open={OpenScheduledMessage}
                                        isScheduleMsg={true}
                                        ContactIDs={[...(OperatingScheduledMessage?.ContactIds ?? []),
                                        ...(OperatingScheduledMessage?.PhoneNumbers?.filter(
                                            x => Contacts?.some(y => y?.MaskedPhoneNumber?.replace("+", "") === x)
                                        ) ?? [])]}
                                        GroupIDs={OperatingScheduledMessage?.Groups?.map((x) => x.ID)}
                                        Message={OperatingScheduledMessage?.Message}
                                        ScheduleType={OperatingScheduledMessage?.Type}
                                        ScheduleDateTime={OperatingScheduledMessage?.NextScheduledDateTime}
                                        ScheduleEndDateTime={OperatingScheduledMessage?.EndScheduledDateTime}
                                        PhoneNumbers={OperatingScheduledMessage?.PhoneNumbers?.filter(x => Contacts?.some(y => y.MaskedPhoneNumber.replace("+", "") !== x))}
                                        handleClose={() => closeSendMessage(true)}
                                        handleSuccess={() => handleSuccess(true)}
                                        showScheduleType={true}
                                        ScheduledMessageID={IsDuplicate ? undefined : OperatingScheduledMessage?.ID}
                                        IsDuplicate={IsDuplicate}
                                        UnsubscribeContactCount={unsubscribeContactsCount(OperatingScheduledMessage?.Groups?.map(x => x.ID))}
                                        Campaign={OperatingScheduledMessage?.Campaign?.ID ? OperatingScheduledMessage?.Campaign : undefined}
                                        IsCampaign={isCampaign}
                                        SetIscompaign={(value: boolean) => setIsCampaign(value)}
                                        MultiMedia={OperatingScheduledMessage?.Media}
                                    />
                                )
                            }
                            {
                                !IsMobileDevice && Boolean(anchorEl) &&
                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={handleCloseFilter}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
                                >
                                    <FilterComponent
                                        Filters={filterOptions}
                                        HandleApplyFilters={handleApplyFilters}
                                        OnClose={handleCloseFilter}
                                    />
                                </Popover>
                            }
                            {
                                Show && (
                                    <ConfirmDialog
                                        onClose={closeConfirmDialog}
                                        Show={Show}
                                        Text={Text}
                                        ButtonName={ButtonName}
                                        IsMobileDevice={IsMobileDevice}
                                        Loading={IsLoading}
                                    />
                                )
                            }
                            {
                                openMassAction && (
                                    <ConfirmDialog
                                        onClose={closeMassActionConfirmDialog}
                                        Show={openMassAction}
                                        Text={Text}
                                        ButtonName={ButtonName}
                                        IsMobileDevice={IsMobileDevice}
                                        Loading={IsLoading}
                                    />
                                )
                            }
                            {
                                IsMobileDevice && MobileMenu && (
                                    <Dialog
                                        fullWidth
                                        onClose={CloseMobileMenu}
                                        aria-labelledby="responsive-dialog-title"
                                        open={true}
                                        // BackdropProps={{ style: { backgroundColor: "transparent" } }}
                                        classes={{ paper: "br-1 dialogue-shadow w-p-70 bg-color-menu-bg" }}
                                    >
                                        <DialogTitle className="dialog-header">
                                            <div className="h1 d-flex" id="customized-dialog-title">
                                                {OperatingScheduledMessage != undefined &&
                                                    UtilityService.trimMessage(contactName(OperatingScheduledMessage), 12)}
                                                <Tooltip title="Close" placement="bottom">
                                                    <span className="ml-auto">
                                                        <CancelIcon

                                                            className={"c-pointer"}
                                                            onClick={(e: any) => {
                                                                e.stopPropagation();
                                                                CloseMobileMenu();
                                                            }}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </DialogTitle>
                                        <DialogContent className={"mln-1 o-hidden pt-0"}>
                                            <MenuItemRenderer MenuData={getMenuActions(OperatingScheduledMessage)} OnClick={CloseMobileMenu} />
                                        </DialogContent>
                                    </Dialog>
                                )
                            }
                        </div>
                    </PullToRefresh>
                </>
    )
}

export default ScheduledMessage;